import styled from "styled-components";

/**
 * Wrapper do GuestSelector
 * Define o layout principal e o espaçamento.
 */
export const GuestSelectorWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing(1)} 0;
  gap: ${({ theme }) => theme.spacing(2)};
  flex-direction: column;
  position: relative;
  display: flex;
`;

/**
 * Wrapper do campo de entrada
 * Configura o layout do botão para abrir o dropdown.
 */
export const InputWrapper = styled.div`
  color: ${({ theme }) => theme.colors.darkGray};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ theme }) => theme.spacing(1.5)}
    ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;
  background-color: transparent;
  align-items: center;
  cursor: pointer;
  display: flex;
`;

/**
 * Conteúdo do campo de entrada
 * Estiliza os ícones e os valores dos hóspedes.
 */
export const InputContent = styled.div`
  color: ${({ theme }) => theme.colors.darkGray};
  gap: ${({ theme }) => theme.spacing(2)};
  margin-right: ${({ theme }) => theme.spacing(3)};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  display: flex;

  span {
    gap: ${({ theme }) => theme.spacing(1)};
    align-items: center;
    display: flex;
  }
`;

/**
 * Ícone de seta para abrir/fechar o dropdown
 * Adiciona animação para rotação ao abrir/fechar.
 */
export const ArrowDown = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isOpen",
})<{ isOpen: boolean }>`
  transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "none")};
  color: ${({ theme }) => theme.colors.lightGray};
  transition: transform 0.3s ease-in-out;

  & * {
    color: ${({ theme }) => theme.colors.darkGray};
    fill: ${({ theme }) => theme.colors.darkGray};
  }
`;
